import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'

import type { SxProps, Theme } from '@mui/material/styles'

const MENU_ITEM_DISABLED_SX = {
  color: 'text.disabled',
  '& .MuiListItemIcon-root': { color: 'text.disabled' },
} as const

type TooltipMenuItemProps = {
  tooltip?: string
  disabled?: boolean
  sx?: SxProps<Theme>
  onClick: (event: React.MouseEvent) => void
  children: React.ReactNode
}

/**
 * MenuItem with an explanatory tooltip shown while disabled. MUI Menu keyboard navigation only
 * reaches MenuItems that are direct DOM children — the usual Tooltip-wrapped <span> workaround
 * makes the item unreachable by arrow keys. Tooltip adds no DOM node (it clones its child), so
 * this keeps the MenuItem direct and emulates disabled (aria-disabled + guarded onClick + dimmed
 * look) instead of the real `disabled` prop, which would suppress the tooltip's hover events.
 */
const TooltipMenuItem: React.FC<TooltipMenuItemProps> = ({ tooltip = '', disabled = false, sx, onClick, children }) => (
  <Tooltip arrow disableInteractive title={disabled ? tooltip : ''}>
    <MenuItem aria-disabled={disabled} sx={disabled ? MENU_ITEM_DISABLED_SX : sx} onClick={disabled ? undefined : onClick}>
      {children}
    </MenuItem>
  </Tooltip>
)

export default TooltipMenuItem
